import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { MainContainer, Row, Col } from '@navent-jobs/ui-kit/components/grid'
import { HeaderComponent, HeaderContent } from './mixins'
import NotificationByCart from '../Cart'
import SignedInHeader from './SignedInHeader'
import LoginFlowHeader from './LoginFlowHeader'

const loginFlowPaths = ['/empresas/registro', '/empresas/ingreso', '/empresas/recupero-clave', '/empresas/cambio-clave']

const Component = ({ hasSidebar, showTitle, showCart, typeNotification }) => {
  const location = useLocation()
  const isLoginFlow = useMemo(
    () => loginFlowPaths.some((path) => location.pathname.startsWith(path)),
    [location.pathname]
  )

  const extraOptionsIsNotLoginFlow = () => {
    if (isLoginFlow) {
      return null
    }

    return <NotificationByCart isOpened={showCart} typeNotification={typeNotification} />
  }

  return (
    <HeaderComponent hasSidebar={hasSidebar}>
      <MainContainer>
        <Row>
          <Col>
            <HeaderContent>
              {isLoginFlow ? <LoginFlowHeader /> : <SignedInHeader showTitle={showTitle} />}
            </HeaderContent>
          </Col>
        </Row>
      </MainContainer>
      {extraOptionsIsNotLoginFlow()}
    </HeaderComponent>
  )
}

const state = ({ cartStoreV2 }) => {
  return { showCart: cartStoreV2.modal.open, typeNotification: cartStoreV2.notification.type }
}
export default connect(state)(Component)
